import { MenuItem, MenuItemProps, Tooltip, TooltipProps } from '@cmg/design-system';
import React from 'react';

export type Props = Readonly<
  MenuItemProps & {
    tooltipProps?: Omit<TooltipProps, 'children' | 'ref' | 'title'> & {
      title?: Exclude<TooltipProps['title'], undefined>;
    };
  }
>;

const MenuItemWithDisabledTooltip: React.FC<Props> = ({
  children,
  tooltipProps,
  ...menuitemProps
}) => {
  if (menuitemProps.disabled) {
    return (
      <Tooltip title="" {...tooltipProps}>
        <div data-testid="menu-item-tooltip-container">
          <MenuItem {...menuitemProps}>{children}</MenuItem>
        </div>
      </Tooltip>
    );
  }

  return <MenuItem {...menuitemProps}>{children}</MenuItem>;
};

export default MenuItemWithDisabledTooltip;
